import React from 'react';
import {
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Tooltip
} from '@material-ui/core';
import { API_URL } from '../../constants/api';
import CancelIcon from '@material-ui/icons/Cancel';
import EditIcon from '@material-ui/icons/Edit';
import { apiBatchRequest, apiPost, apiRequest } from '../../utils/api_service';
import SaveIcon from '@material-ui/icons/Save';
import { ShowToast, toastType } from '../../utils/toast-service';
import {
  getCurrentPayCycleStartDate,
  isDateInPreviousPayCycle,
  isGridFormValid,
  IsSectionVisible,
  UpdateColumnWithConfiguration
} from '../../utils/helper';
import GridTable from '../common/Table/Table';
import { DateFormat, SECTIONS } from '../../constants/appConstants';
import { DataCenterPropertySplitColumnList } from '../../constants/MockData';
import _ from 'lodash';
import DeleteIcon from '@material-ui/icons/Delete';
import ConfirmDialog from '../common/Dailogbox/confirmDailog';
import moment from 'moment';

// Datacenter Property Configuration Component to Assign Leadership Allocation %
class ConfigureDatacenterPropertySplit extends React.Component {
  // Constructor to set initial state
  constructor(props) {
    super(props);
    this.state = {
      isInAddMode: false,
      configuration: [],
      selectedEditRowId: undefined,
      updateData: {
        percentSplit: 0,
        propertyId: 0,
        property: '',
        applicableFrom: null,
        configurationId: 0,
        minDate: getCurrentPayCycleStartDate()
      },
      DataCenterPropertyColumnList: _.clone(DataCenterPropertySplitColumnList),
      isDelete: false,
      showWarningMessage: false,
      confirmMessage: '',
      DatacenterPropertyConfigurationData: []
    };
  }

  // Method to get APIs data before Components are mounted
  componentDidMount() {
    this.getMasterData();
  }

  // Get master data from DB using APIs
  getMasterData = () => {
    this._asyncRequest = apiBatchRequest([
      {
        url: API_URL.Users.GetDatacenterPropertyConfiguration,
        key: 'DatacenterPropertyConfigurationData'
      },
      {
        url: API_URL.Property.GetPropertyMasterData,
        key: 'propertyMasterData'
      }
    ])
      .then(({ DatacenterPropertyConfigurationData, propertyMasterData }) => {
        this._asyncRequest = null;
        if (DatacenterPropertyConfigurationData.success !== true) {
          ShowToast('Something went wrong', toastType.ERROR, 5000, 500, 'Server error');
        }

        this.setState({
          DatacenterPropertyConfigurationData: DatacenterPropertyConfigurationData.data || [],
          configuration: DatacenterPropertyConfigurationData.config || [],
          propertyMasterData: propertyMasterData.data || []
        });
      })
      .catch(() => {
        this._asyncRequest = null;
      });
  };

  // Get Property wise Leadership Allocation % of Datacenter Properties
  GetDatacenterPropertyConfigurationData = () => {
    apiRequest({
      url: API_URL.Users.GetDatacenterPropertyConfiguration
    }).then(({ data: response }) => {
      this.setState({
        DatacenterPropertyConfigurationData: response || []
      });
    });
  };

  // Cancel Edit mode
  cancelMode = () => {
    this.setState({ selectedEditRowId: undefined, isInAddMode: false, updateData: undefined });
  };

  // Check validations
  isValidForm = () => {
    let IsValid = true;
    const { updateData, DataCenterPropertyColumnList } = this.state;
    DataCenterPropertyColumnList.forEach((ele) => {
      isGridFormValid(updateData[ele.key], ele, updateData);
      if (ele.isInErrorState === true) {
        IsValid = false;
      }
    });
    this.setState({ DataCenterPropertyColumnList }, this.forceUpdate());
    return IsValid;
  };

  // Check if configuration for the Property for the selected period is exists
  isPropertyConfigurationExists = () => {
    const { updateData, DatacenterPropertyConfigurationData } = this.state;
    const existingRecord = DatacenterPropertyConfigurationData.find(y => moment(y.applicableFrom)
      .format(DateFormat) === moment(updateData.applicableFrom).format(DateFormat) &&
      y.configurationId !== updateData.configurationId && y.propertyId === updateData.propertyId);
    if (existingRecord !== undefined) {
      const message = 'Applicable From: ' + moment(existingRecord.applicableFrom).format(DateFormat) + ' already exists for ' + existingRecord.property + '. If you want to update any information please edit that particular record.';
      ShowToast(message, toastType.WARNING, 5000, 500);
      return true;
    }
    return false;
  }

  // Save updated configuration record
  saveUpdatedRecord = () => {
    if (this.isPropertyConfigurationExists() || !this.isValidForm()) { return false; } else {
      const newParam = this.state.updateData;
      const params = {
        propertyId: newParam.propertyId,
        percentSplit: newParam.percentSplit,
        applicableFrom: moment(newParam.applicableFrom).format(DateFormat),
        configurationId: newParam.configurationId,
        StatusId: 1,
        minDate: getCurrentPayCycleStartDate()
      };
      this.SaveDatacenterPropertyConfiguration(params);
    };
  }

  // Save configuration records into DB with updated values
  SaveDatacenterPropertyConfiguration = (params) => {
    apiPost({
      url: API_URL.Users.UpdateGetDatacenterPropertyConfiguration,
      params: {},
      postBody: params
    }).then(({ data: response }) => {
      if (response.success === true) {
        ShowToast(this.state.isInAddMode ? 'Record added successfully.' : 'Record updated successfully.', toastType.SUCCESS, 5000, 500);
        this.setState({
          updateData: undefined,
          selectedEditRowId: undefined,
          isInAddMode: false,
          showWarningMessage: false,
          confirmMessage: ''
        }, () => this.GetDatacenterPropertyConfigurationData());
      } else {
        ShowToast(response.errorMessage, toastType.ERROR, 5000, 500);
      }
    });
  };

  // Check if Edit icon should be visible for the record
  IsEditVisible = (cellInfo) => {
    if (isDateInPreviousPayCycle(moment(cellInfo.applicableFrom).format(DateFormat))) {
      return false;
    }
    return true;
  }

  // Open record in Edit mode
  EditRecord = (cellInfo) => {
    if (this.state.isInAddMode === true && this.state.updateData !== null) {
      ShowToast('You can modify one row at a time!', toastType.WARNING, 5000, 500);
      return false;
    } else {
      const DataCenterPropertyColumnList = _.cloneDeep(DataCenterPropertySplitColumnList);
      DataCenterPropertyColumnList.forEach(x => {
        if (x.key === 'applicableFrom') {
          x.minDate = getCurrentPayCycleStartDate();
        }
      });
      cellInfo.minDate = getCurrentPayCycleStartDate();
      this.setState({
        selectedEditRowId: { key: 'configurationId', value: cellInfo.configurationId },
        isInAddMode: false,
        updateData: { ...cellInfo },
        DataCenterPropertyColumnList
      });
    }
  }

  // Render Edit/Update/Cancel etc. Action buttons for the record based on conditions 
  renderActionColumn = (cellInfo) => {
    return (
      <>
        {this.state.selectedEditRowId !== undefined && cellInfo.configurationId === this.state.selectedEditRowId.value
          ? (
            <>
              <Tooltip title="Save Record">
                <IconButton aria-label={'refreshData'} size="small" onClick={() => { }}>
                  <SaveIcon fontSize="small" size="small" onClick={this.saveUpdatedRecord} />
                </IconButton>
              </Tooltip>
              <Tooltip title="Cancel">
                <IconButton aria-label={'refreshData'} size="small" onClick={this.cancelMode}>
                  <CancelIcon fontSize="small" size="small" />
                </IconButton>
              </Tooltip>
            </>
          )
          : <>{(IsSectionVisible(SECTIONS.DATA_CENTER_CONFIGURATION, SECTIONS.CONFIGURE_SDC_PROPERTY_SPLIT, SECTIONS.ADD_EDIT)) && this.IsEditVisible(cellInfo) && (
            <Tooltip title="Edit Record">
              <IconButton
                aria-label={'refreshData'}
                size="small"
                onClick={() => {
                  this.EditRecord(cellInfo);
                }}
              >
                <EditIcon fontSize="small" size="small" />
              </IconButton>
            </Tooltip>
          )}
            {(IsSectionVisible(SECTIONS.DATA_CENTER_CONFIGURATION, SECTIONS.CONFIGURE_SDC_PROPERTY_SPLIT, SECTIONS.ADD_EDIT)) && this.IsEditVisible(cellInfo) && (
              <Tooltip title="Delete Record">
                <IconButton
                  aria-label={'refreshData'}
                  size="small"
                  onClick={() => {
                    this.deleteRecord(cellInfo);
                  }}
                >
                  <DeleteIcon fontSize="small" size="small" />
                </IconButton>
              </Tooltip>
            )}
          </>
        }
      </>
    );
  };

  /**
 * delete record
 */
  deleteRecord(cellInfo) {
    if (this.state.isInAddMode === true && this.state.updateData !== null) {
      ShowToast('You can modify one row at a time!', toastType.WARNING, 5000, 500);
      return false;
    } else {
      this.setState({
        showWarningMessage: true,
        confirmMessage: 'Do you want to delete this record ?',
        updateData: cellInfo
      });
    }
  };

  /**
 * handle dialog box click event
 * @param {*} e
 */
  onClickHandle(e) {
    if (e) {
      const newParam = this.state.updateData;
      const params = {
        propertyId: newParam.propertyId,
        percentSplit: newParam.percentSplit,
        applicableFrom: moment(newParam.applicableFrom).format(DateFormat),
        configurationId: newParam.configurationId,
        StatusId: 2
      };
      this.SaveDatacenterPropertyConfiguration(params);
    } else {
      this.setState({
        showWarningMessage: false,
        confirmMessage: ''
      });
    }
  }

  // Handle edit event of values in the table row
  handleTableEditChange = (value, fieldName, row, addMode) => {
    const { DataCenterPropertyColumnList, propertyMasterData } = this.state;
    const param = { ...this.state.updateData };
    if (fieldName === 'property') {
      param.propertyId = (propertyMasterData.find(x => x.propertyName === value) || {}).propertyId;
    }
    param[fieldName] = value;
    isGridFormValid(value, DataCenterPropertyColumnList.find(x => x.key === fieldName), param);

    this.setState({ updateData: param });
  };

  // Add new configuration record
  AddNewRecord = () => {
    if (this.state.isInAddMode === true) {
      ShowToast('You can add one row at a time!', toastType.WARNING, 5000, 500);
      return false;
    }
    const DataCenterPropertyColumnList = _.cloneDeep(DataCenterPropertySplitColumnList);
    DataCenterPropertyColumnList.forEach(x => {
      if (x.key === 'applicableFrom') {
        x.minDate = getCurrentPayCycleStartDate();
      }
    });

    const rowNew = {
      propertyId: 0,
      property: 0,
      prercentsplit: 0,
      applicableFrom: null,
      configurationId: 0,
      minDate: getCurrentPayCycleStartDate()
    };
    this.setState({ isInAddMode: true, selectedEditRowId: { key: 'configurationId', value: 0 }, updateData: rowNew, DataCenterPropertyColumnList });
  };

  // Render components based on conditions
  render() {
    const { configuration, propertyMasterData, DatacenterPropertyConfigurationData, isInAddMode, selectedEditRowId, updateData, DataCenterPropertyColumnList } = this.state;
    const EditSource = [];
    EditSource.push(
      { key: 'propertyMasterData', data: propertyMasterData }
    );

    return (
      <>
        {this.state.showWarningMessage && (
          <ConfirmDialog
            IsOpen={this.state.showWarningMessage}
            Message={this.state.confirmMessage}
            OnHandelClick={(isValid) => { this.onClickHandle(isValid); }}
            AgreeText="Yes"
            DisAgreeText="No"
          ></ConfirmDialog>
        )}
        <Table
          aria-labelledby="tableMenuTitle"
          size={'small'}
          aria-label="configuration table"
        >
          <TableHead>
            <TableRow>
              <TableCell
                key={'configureHeader'}
                className="content-header"
                colSpan={2}
              >
                <div className="content-header d-flex">
                  {' '}
                  <div
                    className="col-xs-11"
                    style={{ display: 'inline-block', alignItems: 'center' }}
                  >
                    Datacenter Property Configuration
                                    </div>
                </div>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell>
                <GridTable
                  columns={UpdateColumnWithConfiguration(DataCenterPropertyColumnList, configuration, [])}
                  data={DatacenterPropertyConfigurationData}
                  config={DataCenterPropertyColumnList}
                  renderActionColumn={this.renderActionColumn}
                  selectedEditRowId={selectedEditRowId}
                  isInAddMode={isInAddMode}
                  EditSource={EditSource}
                  handleTableEditChange={this.handleTableEditChange}
                  updateData={updateData}
                  isInline={true}
                  AddNewRecord={{ action: this.AddNewRecord, title: 'Add New Datacenter Property Configuration', visible: IsSectionVisible(SECTIONS.DATA_CENTER_CONFIGURATION, SECTIONS.CONFIGURE_SDC_PROPERTY_SPLIT, SECTIONS.ADD_EDIT) }}
                ></GridTable>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </>
    );
  };
}

export default ConfigureDatacenterPropertySplit;
